module.exports = __webpack_public_path__ + "public/images/art.204e3e44b5109afac0f7a5def0c499b5.png";